const translations = {
    createFaaReport: 'Create FAA Report'
};

export default translations;
